// Resolves private reviewer-evidence media (gs://ri-site-capture/…) to a
// fetchable URL through the QA server's authenticated proxy — the same
// endpoint the QA UI uses to display these images (useVideoUrl). Export-only:
// the site-survey editor's own photo viewer keeps its https-only path.

import type { GcsProxy } from "./summaryPhotoFill";

const QA_API_URL =
  (import.meta as { env?: Record<string, string> }).env?.VITE_QA_API_URL ||
  "http://localhost:3100";

/**
 * A gs:// → proxy-URL resolver bound to the current user's Firebase token, or
 * undefined when not signed in (so gs:// evidence is dropped rather than
 * producing an unauthenticated request). Fetch the token once per export.
 *
 * The Firebase client is imported lazily: its module self-initializes storage
 * at load, which throws outside a browser (unit tests), so it must not be
 * pulled into the pure export chain until an export actually runs.
 */
export async function buildGcsProxy(): Promise<GcsProxy | undefined> {
  const { getFirebaseIdToken } = await import("@/shared/integrations/firebase/client");
  const token = await getFirebaseIdToken().catch(() => null);
  if (!token) return undefined;
  return (gsUri: string) =>
    `${QA_API_URL}/v1/qa-video?uri=${encodeURIComponent(gsUri)}&token=${encodeURIComponent(token)}`;
}
